<template>
  <NuxtLayout name="default">
    <div class="error-page">
      <h1 class="h1 text-center">Error №{{$error?.statusCode || 404}}</h1>
      <h2 class="h2 text-center">
        <template v-if="$error?.statusCode === 404">
          Page Not Found
        </template>
        <template v-else>
          Unhandled Error. Try again later.
        </template>
      </h2>

      <lottie src="/lottie/404.lottie"/>
      <pre style="display:none;">
      {{ $error }}
      </pre>
      <a href="/" class="btn fill-white" style="width: 250px;max-width: 100%;margin: auto;margin-top: 50px">Home</a>
    </div>
  </NuxtLayout>
</template>

<script setup lang="ts">
import getMeta from "~/classes/getMeta";

definePageMeta({
  layout: "default",
  name: "error",
});

const $error = useError();

useHead(getMeta(
  'Ошибка №'+($error?.statusCode || 404),
  'Try again'
))
</script>

<style lang="scss">
</style>
